import * as firebase from 'firebase/app'
import 'firebase/auth'

const Auth = {
  isAuthenticated: false,
  authenticate(cb) {
    this.isAuthenticated = true
    setTimeout(cb, 100) // fake async
  },
  signout(cb) {
    this.isAuthenticated = false
    this.handleLogout()
    setTimeout(cb, 100)
  },
  handleLogout() {
      firebase.auth().signOut()
        .then(() => console.log("logout!"))
        .catch(error => console.error(error.code +" - "+ error.message));
  }
}   

export default Auth;